'use client';

import { RoutesEnum } from '@/enums/route.enum';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

const HomeWrapper = () => {
  const router = useRouter();

  useEffect(() => {
    router.replace(RoutesEnum.CALENDAR);
  }, []);

  return null;
};

export default HomeWrapper;
